import { useState } from "react";
import { Link } from "react-router-dom";
import { FiBookOpen, FiArrowUpRight } from "react-icons/fi";
import useCurrencyStore from "store/currencyStore";
import { priceInCurrency, formatCurrencyAmount } from "utils";

const HomeBook = ({ book }) => {
	const [coverFailed, setCoverFailed] = useState(false);
	const currency = useCurrencyStore((state) => state.currency);
	const amount = priceInCurrency(book.prices, currency, book.price, book.zwl_price);
	const free = book.isFree === true || book.isFree === 1 || book.isFree === "1";
	const price = free ? "Free" : book.sellable && amount !== null && Number(amount) > 0 ? formatCurrencyAmount(amount, currency) : book.subscription ? "Subscription eligible" : "View access options";
	return (
		<Link className="home-book" to={`/book/${book.id}`} aria-label={`${book.title}${book.author ? ` by ${book.author}` : ""}. ${price}`}>
			<div className="home-book-art">{book.book_cover?.url && !coverFailed ? <img src={book.book_cover.url} alt="" loading="lazy" onError={() => setCoverFailed(true)} /> : <div className="home-book-fallback"><FiBookOpen aria-hidden="true" /><span>{book.title}</span></div>}<span className="home-book-open"><FiArrowUpRight aria-hidden="true" /></span>{free && <span className="home-book-badge">FREE</span>}</div>
			<div className="home-book-info"><h3>{book.title}</h3>{book.author && <p>{book.author}</p>}<span className="home-book-price">{price}</span></div>
		</Link>
	);
};
export default HomeBook;
